// extracted by mini-css-extract-plugin
export default {"chatbot-slider":"_3IBx8","chatbotSlider":"_3IBx8"};